module.exports = __webpack_public_path__ + "static/media/taskCover@3x.dfd8af43.png";